import {batch} from 'react-redux';

import {
  resetDeviceProperties,
  setDeviceNameInStore,
  setDeviceProperties,
  setDevicePropertyName,
} from '@/actions/deviceInfoActions';
import {updateLoading} from '@/actions/loadingActions';
import {hidePopUp, showPopUp} from '@/actions/modalActions';
import {
  setTopMenuProperties,
  showAlert,
  topButtonProperties,
  topButtonTertiaryProperties,
  updateActiveMenu,
} from '@/actions/setupActions';
import {reset} from '@/actions/timeZoneAction';
import {getDevicePropsSystem, postSettingSystem} from '@/api/systemApi';
import {ALERT_TYPE} from '@/constants/enums';
import {
  BACK,
  CANCEL,
  DEVICE_SETTING,
  DISCARD,
  HOME_SCREEN_ADDRESS,
  REBOOT,
  SAVE,
  SYSTEM_SETTING,
} from '@/constants/pcConstAppData';
import {navigateTo} from '@/libs/appHelper';
import {formatMessage} from '@/libs/intlHelper';
import {isAlphaNumeric} from '@/libs/stringHelper';
import {getZone} from '@/libs/timezoneHelper';
import {isChangedDeviceSetting} from '@/selectors/deviceInfoSelector';

import {initTimeZone} from './timeZoneBusiness';

export function validateDeviceName(value, dispatch) {
  let result = true;

  if (!isAlphaNumeric(value)) {
    dispatch(
      showAlert({
        alertShow: true,
        alertText: formatMessage({id: 'toast.deviceSetting.failedDeviceNameSymbol.message'}),
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
    result = false;
  } else if (value === undefined || value === '') {
    dispatch(
      showAlert({
        alertShow: true,
        alertText: formatMessage({id: 'toast.deviceSetting.failedDeviceNameEmpty.message'}),
        alertStyle: ALERT_TYPE.ALERT_DANGER,
      }),
    );
    result = false;
  } else {
    // setDeviceName(value);
    // dispatch(setDeviceNameInStore(value));
    // if (originDeviceName !== value) {
    //   setIsButtonBackPopUp(true);
    // }
  }

  return result;
}

export function changeDeviceName(value) {
  return async (dispatch) => {
    batch(() => {
      if (!validateDeviceName(value, dispatch)) return;

      dispatch(setDeviceNameInStore(value));
      dispatch(setDevicePropertyName(value));
    });
  };
}

export function resetDeviceSetting() {
  return async (dispatch) => {
    batch(() => {
      dispatch(reset());
      dispatch(resetDeviceProperties());
      // todo handle reset device state
    });
  };
}

export function discardSettingChanges(cb = null) {
  return async (dispatch) => {
    batch(() => {
      dispatch(hidePopUp());
      dispatch(resetDeviceSetting());
    });

    if (cb) cb();
  };
}

export function saveAndReboot() {
  return async (dispatch, getState) => {
    try {
      const {deviceInfoStore, timeZoneStore} = {...getState()};
      const {deviceProperties} = deviceInfoStore;
      const {geoArea, region, date, time, isAutoSync} = timeZoneStore;
      const {deviceName, organization} = deviceProperties;

      await postSettingSystem({
        hostName: deviceName,
        isAutoDateTime: isAutoSync,
        isAutoTimezone: isAutoSync,
        organization,
        date,
        time,
        timezone: getZone(geoArea, region),
      });
    } catch (error) {
      console.log('saveAndReboot error', error);
    } finally {
      batch(() => {
        dispatch(
          updateLoading({
            showLoading: true,
            loadingText: formatMessage({id: 'loading.restarting.message'}),
            loadingClickEvent: undefined,
          }),
        );
        dispatch(hidePopUp());
      });
    }
  };
}

export function showSaveAndRebootModal() {
  return async (dispatch) => {
    const popUpButton = [
      {
        id: CANCEL,
        isPrimaryButton: false,
        onClick: () => dispatch(hidePopUp()),
        label: formatMessage({id: 'general.label.cancel'}),
      },
      {
        id: REBOOT,
        isPrimaryButton: true,
        onClick: () => dispatch(saveAndReboot()),
        label: formatMessage({id: 'general.label.reboot'}),
      },
    ];
    dispatch(
      showPopUp({
        popUpTitle: formatMessage({id: 'modal.saveDeviceSetting.title'}),
        popUpText: formatMessage({id: 'modal.saveDeviceSetting.messageSave'}),
        popUpQuestion: '',
        popUpButton,
      }),
    );
  };
}

export function showValidateChangesModal(cb = null) {
  return async (dispatch) => {
    const popUpButton = [
      {
        id: CANCEL,
        isPrimaryButton: false,
        onClick: () => dispatch(hidePopUp()),
        label: formatMessage({id: 'general.label.cancel'}),
      },
      {
        id: DISCARD,
        isPrimaryButton: false,
        onClick: () => dispatch(discardSettingChanges(cb)),
        label: formatMessage({id: 'general.label.discard'}),
      },
      {
        id: SAVE,
        isPrimaryButton: true,
        onClick: () => dispatch(showSaveAndRebootModal()),
        label: formatMessage({id: 'general.label.save'}),
      },
    ];
    dispatch(
      showPopUp({
        popUpTitle: formatMessage({id: 'modal.saveDeviceSetting.title'}),
        popUpText: formatMessage({id: 'modal.saveDeviceSetting.messageSaveByChange'}),
        popUpQuestion: '',
        popUpButton,
      }),
    );
  };
}

export function backAction() {
  return async (dispatch, getState) => {
    const isChanged = isChangedDeviceSetting({...getState()}); // handle from selector

    const navigateToMenu = () => navigateTo(HOME_SCREEN_ADDRESS);

    if (isChanged) {
      dispatch(showValidateChangesModal(navigateToMenu));
    } else {
      dispatch(resetDeviceSetting());
      navigateToMenu();
    }
  };
}

export function initDeviceSetting() {
  return async (dispatch) => {
    try {
      /// TOP MENU
      batch(() => {
        dispatch(
          setTopMenuProperties({
            topButtonProperties: {
              id: SAVE,
              label: formatMessage({id: 'general.label.save'}),
              disabled: false,
              onClick: () => dispatch(showSaveAndRebootModal()),
            },
            backButtonProperties: {
              id: BACK,
              label: '',
              disabled: false,
              onClick: () => dispatch(backAction()),
            },
            titleMenuProperties: SYSTEM_SETTING,
          }),
        );
        dispatch(topButtonTertiaryProperties(undefined));
        dispatch(updateActiveMenu(DEVICE_SETTING));
        ///
      });

      const response = await getDevicePropsSystem();
      await dispatch(initTimeZone());

      dispatch(
        setDeviceProperties({
          deviceName: response.DeviceName,
          originDeviceName: response.DeviceName,
          organization: response.Organization,
          originOrganitation: response.Organization,
        }),
      );
    } catch (error) {
      console.log('initDeviceSetting error', error);
    }
  };
}

export function setDisabledSaveAction(isChanged) {
  return async (dispatch, getState) => {
    const {setupStore} = {...getState()};
    const {topButtonProperties: _topButtonProperties} = setupStore;
    console.log({isChanged});
    dispatch(
      topButtonProperties({
        ..._topButtonProperties,
        disabled: !isChanged,
      }),
    );
  };
}
